module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAAXNSR0IArs4c6QAAAIpJREFUKBXtUrkNgDAMvPAJGiZBNIzFABR0DMAA9MwIxJhgnhAJ0aTHUqy7k2NLPqu8GM28MJTCGTSt6JoKbV1ewp1pGEH9AGSp05MY0awZmtiJwpk3xy1ihtEEhKFVcMwM7sGP6AsC3w/v+r+BuGDeW/HkUZqIr9LlOSQ2YvXHbsV/JYeD49kQvAOSnCOLg93u/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/RE.png
// module id = 1250
// module chunks = 0